export default "__VITE_ASSET__Djcq1oTH__"